import PropTypes from "prop-types";
import { PreloadLink } from "../../../theme";
import { ChevronRightIcon, Divider, Typography } from "../../../themeV2";
import { Influencer } from "../../../domain";
import Category from "./Category";
import ResultSection from "./ResultSection";
import css from "./Views.module.css";

export function DefaultView({ recentShops, categories, onClick }) {
  return (
    <div className={css.defaultView}>
      <Typography variant="label-lg" color="variant" weight="bold" as="p">
        Quick links
      </Typography>
      {recentShops.length > 0 && (
        <div className={css.quickLinks}>
          {recentShops.map((shop) => (
            <PreloadLink
              className={css.shop}
              onClick={onClick}
              to={`/${shop.route}`}
              endpoints={Influencer.getPreloadEndpoints(shop)}
              key={shop.influencerId}
            >
              <img
                className={css.avatar}
                src={shop.avatarUrl}
                alt=""
                width="40"
                height="40"
              />
              <small>{shop.name}</small>
            </PreloadLink>
          ))}

          <div className={css.dividerWrap}>
            <Divider orientation="vertical" decorative />
          </div>

          <PreloadLink className={css.shop} onClick={onClick} to="/products">
            <span className={css.iconCircle}>
              <ChevronRightIcon className={css.chevronIcon} />
            </span>
            <small>Browse Products</small>
          </PreloadLink>

          <PreloadLink className={css.shop} onClick={onClick} to="/shops">
            <span className={css.iconCircle}>
              <ChevronRightIcon className={css.chevronIcon} />
            </span>
            <small>Browse Shops</small>
          </PreloadLink>
        </div>
      )}

      <Typography variant="label-lg" color="variant" weight="bold" as="p">
        Popular Categories
      </Typography>
      <div className={css.categories}>
        {categories.map((category) => (
          <Category
            key={category.categoryId}
            category={category}
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
}

DefaultView.propTypes = {
  recentShops: PropTypes.array,
  categories: PropTypes.array,
  onClick: PropTypes.func,
};

export function SearchResultsView({
  totalCount,
  activeSections,
  onClick,
  query,
}) {
  return (
    <>
      <div className={css.resultsHeader}>
        <Typography variant="label-md" color="variant">
          {totalCount} result{totalCount !== 1 ? "s" : ""}
        </Typography>
      </div>
      {activeSections.map(([kind, items]) => (
        <ResultSection
          key={kind}
          kind={kind}
          items={items}
          onClick={onClick}
          query={query}
        />
      ))}
    </>
  );
}

SearchResultsView.propTypes = {
  totalCount: PropTypes.number.isRequired,
  activeSections: PropTypes.array,
  onClick: PropTypes.func,
  query: PropTypes.string,
};
